import { PdcPage } from './PdcPage'

export default PdcPage
export type { PdcPageProps } from './PdcPage'
